module.exports = __webpack_public_path__ + "assets/img/warrior-name-38994f10.png";